var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'is-required': _vm.required}},[_c('select',{staticClass:"form-control",attrs:{"id":_vm.id,"placeholder":_vm.placeholder,"required":_vm.required ? true : false}})])
}
var staticRenderFns = []

export { render, staticRenderFns }